var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.brandLogo)?_c('div',{staticClass:"relative mr-2"},[_c('c-ltk-avatar',{staticClass:"avatar",attrs:{"size":"24","src":_setup.brandLogo}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }